export default {
  title: 'סטיות עמלות קבצים',
  columns: {
    company: 'חברה',
    product: 'מוצר',
    year: 'שנה',
    policyNumber: 'מספר פוליסה',
    identifiernNumber: 'מספר סוכן',
    actualValue: 'ערך מחושב',
    expectedValue: 'ערך בדוח',
    deviationValue: 'סטייה',
    column: 'עמודה',
    rowNumber: 'שורה',
    actions: 'פעולות',
  },
  actions: {
    approve: 'אשר',
    approveMultiple: 'אשר פערים',
  },
  notifications: {
    success: {
      approveMultiple: {
        title: 'הצלחה',
        message: (count) => `${count} שגיאות אושרו בהצלחה`,
      },
    },
    errors: {
      approve: {
        title: 'שגיאה',
        message: 'התרחשה שגיאה באישור השגיאה',
      },
      approveMultiple: {
        title: 'שגיאה',
        message: 'התרחשה שגיאה באישור השגיאות',
      },
      find: {
        title: 'שגיאה',
        message: 'התרחשה שגיאה בטעינת הנתונים',
      },
    },
  },
};
